import { MutableRefObject } from 'react';
import * as PIXI from "pixi.js"

import * as FBRConstants from '../FBRConstants';
import * as FBRTypes from '../FBRTypes';

const createLoseScreen = (
	backgroundTexture: PIXI.Texture,
	playAgainButtonTexture: PIXI.Texture,
	pixiAppRef: MutableRefObject<PIXI.Application | undefined>,
	globalState: MutableRefObject<FBRTypes.GlobalState>,
) => {
	const mainContainer = new PIXI.Container();
	const mainText = new PIXI.Text(
		'You have lost! :(', 
		{ 
			fontFamily : 'Odibee Sans', 
			fontSize: 43, 
			fill : 0xfefefe, 
			align : 'center',
			wordWrap: true,
			wordWrapWidth: FBRConstants.STAGE_WIDTH*0.715,
		}
	);
	mainText.anchor.set(0.5, 0.5);
	mainText.x = FBRConstants.STAGE_WIDTH/2;
	mainText.y = 535;

	let playAgainButtonSprite = PIXI.Sprite.from(playAgainButtonTexture);
	playAgainButtonSprite.interactive = true;
	playAgainButtonSprite.anchor.set(0.5,0.5);
	playAgainButtonSprite.x = FBRConstants.STAGE_WIDTH/2;
	playAgainButtonSprite.y = FBRConstants.STAGE_HEIGHT - 175;

	let backgroundSprite = PIXI.Sprite.from(backgroundTexture);
	backgroundSprite.x = 0;
	backgroundSprite.y = 0; 
	
	playAgainButtonSprite.on('pointerover', () => {
		playAgainButtonSprite.scale.set(1.07, 1.07);
	});
	
	playAgainButtonSprite.on('pointerdown', () => {
		playAgainButtonSprite.tint = 0x4242aa;
	});
	
	playAgainButtonSprite.on('pointerout', () => {
		playAgainButtonSprite.scale.set(1, 1);
		playAgainButtonSprite.tint = 0xFFFFFF;
	});
	
	playAgainButtonSprite.on('pointerdown', () => {
		const newGlobalState = {
			...FBRConstants.GLOBAL_STATE_DEFAULT,
			...{
				gameStartTime: Date.now(),
				gameState: 'running',
				//maxScore: globalState.current.maxScore,
				//maxLevel: globalState.current.maxLevel,
				maxScore: 0,
				maxLevel: 1,
				allTimeMaxScore: globalState.current.allTimeMaxScore,
				allTimeMaxLevel: globalState.current.allTimeMaxLevel,
			},
		};
		//console.dir(newGlobalState);
		globalState.current = newGlobalState;
		//console.log('game re-started');
	});

	mainContainer.addChild(backgroundSprite);	
	mainContainer.addChild(mainText);	
	mainContainer.addChild(playAgainButtonSprite);	

	const _update = () => {
		if(globalState.current.gameState == 'lost_game') {
			mainText.text = `SCORE\n${globalState.current.maxScore}\n\nLEVEL\n${globalState.current.maxLevel}\n\nYour best score ever was ${globalState.current.allTimeMaxScore} on level ${globalState.current.allTimeMaxLevel}.`;
			mainContainer.visible = true;
		} else {
			mainContainer.visible = false;
		}
	}
	
	return {
		container: mainContainer,
		update: _update,
	};
};

export default createLoseScreen;
